/* eslint-disable jsx-a11y/anchor-is-valid */
import { WebLayout } from "#layouts";
import React from "react";
import { GrowerDetailCard } from "#components";
import { useLocation } from "react-router-dom";

const FieldManagementDetail = () => {
  const location = useLocation();

  const growerId = location?.state?.GrowerId?.id;
  const fieldDetail = location?.state?.fieldDetail;
  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="wrapper-card">
            <div className="row">
              <div className="col-xl-12">
                <form>
                  <div className="row justify-content-between g-3">
                    <GrowerDetailCard GrowerId={growerId} />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="row gy-4">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a>Field Listing</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Field Detail
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-lg-4">
              <div className="detail_wrapper_card">
                <div className="row gy-3 gx-4 gx-xxl-5">
                  <div className="col-md-12 col-lg-12">
                    <div className="common-statistics">
                      <div className="common-info-detail">
                        <h2 className="h4">Field Name</h2>
                        <p className="mb-0">{fieldDetail?.name}</p>
                      </div>
                      <div className="common-info-detail">
                        <h2 className="h4">Acres</h2>
                        <p className="mb-0">{fieldDetail?.area} ac</p>
                      </div>
                      {/* <div className="common-info-detail">
                        <h2 className="h4">Crop</h2>
                        <p className="mb-0">{fieldDetail?.cropName}</p>
                      </div> */}
                      <div className="common-info-detail">
                        <h2 className="h4">Legal Land Description (LLD)</h2>
                        <p className="mb-0 primary_text text-decoration-underline link-offset-1">
                          {`${fieldDetail?.lld1}${fieldDetail?.lld2}${fieldDetail?.lld3}${fieldDetail?.lld4}${fieldDetail?.lld5}${fieldDetail?.lld6}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Array.isArray(fieldDetail?.subFields) &&
          fieldDetail.subFields.length > 0 ? (
            <div className="row gy-4">
              <div className="col-12">
                <div className="sub-heading flex-box mt-4 mb-0">
                  <h2>Sub Fields</h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="common-statistics sub_fields_block">
                  {fieldDetail.subFields.map((item, i) => (
                    <div className="common-info-detail" key={i}>
                      <p className="mb-0">{item?.name}</p>
                      <p className="mb-0">{item?.cropName}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </section>
    </WebLayout>
  );
};

export default FieldManagementDetail;
